import React from "react";
import { motion } from "framer-motion";
import PageWrapper from "./PageWrapper";
import logo1 from "../assets/logo1.jpg";
import logo2 from "../assets/logo2.jpeg";
import logo3 from "../assets/logo3.jpeg";
import logo4 from "../assets/logo4.jpeg";

const Nospartenaires = ({ onFinish }) => {
  const logos = [logo1, logo2, logo3, logo4];

  return (
    <PageWrapper>
      <div className="min-h-screen flex flex-col items-center justify-center bg-white px-4">
        <div className="flex flex-col items-center max-w-4xl mx-auto w-full">
          <motion.h2
            className="text-3xl md:text-4xl font-bold mb-16 text-blue-800 text-center"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Nos Partenaires
          </motion.h2>

          <div className="flex flex-wrap justify-center items-center gap-12 mb-16">
            {logos.map((logo, index) => (
              <motion.div
                key={index}
                className="w-32 h-32 flex items-center justify-center"
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
              >
                <img
                  src={logo}
                  alt={`Partenaire ${index + 1}`}
                  className="max-w-full max-h-full object-contain"
                />
              </motion.div>
            ))}
          </div>

          <motion.button
            onClick={onFinish}
            className="bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 px-8 rounded-full transition duration-300 text-lg mt-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            whileHover={{ scale: 1.05 }}
          >
            Accéder à la plateforme
          </motion.button>

          <motion.p
            className="text-gray-500 text-sm mt-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            © 2024 WebConsulting. Tous droits réservés.
          </motion.p>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Nospartenaires;